<template>
  <Entity class="AppItem" :tag="tag" :item="item" @click="goToApp">
    <!-- <img class="AppItem__img" :src="appPreviewSrc" loading="lazy" importance="low" async="on" > -->
    <picture class="AppItem__img" loading="lazy">
      <img loading="lazy" ref="prevImg">
    </picture>
    <Icon class="AppItem__type" :name="item.type" />
    <div class="AppItem__desc">
      <div class="AppItem__name u-ellipsis">{{item.name}}</div>
      <div class="AppItem__mrkt u-ellipsis">
        <!-- <a class="AppItem__url" :href="item.url" target="_blank" @click.stop="$log">
          {{ item.marketId || item.url }}</a> -->
        <!-- <span class="AppItem__url">{{ item.marketId || item.url }}</span> -->
        {{ item.marketId || item.url }}
      </div>
    </div>
    <slot default />
  </Entity>
</template>

<script>
import Entity from 'components/Entity';
import { getPreviewPng } from 'api/apps';
import ROUTES from 'routes';
import { Route } from 'utils';

export default {
  methods: {
    setPreviewSrc (item) {
      const { id, imageUrls } = item;
      const { previewUrl } = this;
      const { prevImg } = this.$refs;
      const src = (id && id !== -1) ?
        previewUrl || getPreviewPng(id)
      : (imageUrls && imageUrls[0]);

      if (window.__TESTING) {
        prevImg.classList.add('--loaded');
        return (prevImg.src = src);
      }
      prevImg.onload = () => prevImg.classList.add('--loaded');
      setTimeout(() => (prevImg.src = src), 50);
    },

    goToApp (e) {
      if (this.tag !== 'a')
        return;
      const { id: appId, advertiserId: adverId } = this.item;
      e.preventDefault();
      this.$router.push({
        name: ROUTES.ADVER.AUDIENCES,
        params: { adverId },
        query: { appId },
      });
    },
  },

  mounted () {
    const { item, tag } = this;
    if (tag === 'a') {
      this.$el.href = item.id > 0 ?
        new Route(
          ROUTES.ADVER.AUDIENCES,
          { params: { adverId: item.advertiserId }, query: { appId: item.id } }
        )
      : '#';
    }

    this.setPreviewSrc(item);
  },

  props: {
    item: Object,
    previewUrl: String,
    tag: { type: String, default: 'div' },
  },

  components: { Entity },
};

</script>
<style lang="postcss">
.AppItem {
  --pad: 8px;
  --gap: 4px;
  --img-size: 32px;
  --img-shadow-c: rgba(0, 0, 0, 0.2);

  display: flex;
  gap: var(--gap);
  padding: var(--pad);

  font-size: 13px;

  &__mrkt {
    font-size: 11px;

    .Icon { margin-right: 4px; }
  }

  &__desc { overflow: hidden }

  &__name { font-weight: 600 }

  &__img {
    width: var(--img-size);
    height: var(--img-size);
    overflow: hidden;
    flex-shrink: 0;

    box-shadow: 0 2px 4px 0 var(--img-shadow-c);
    border-radius: 3px;

    img {
      width: var(--img-size);
      height: var(--img-size);
    }
  }
}
</style>
